import {EventBus} from "../events/event.bus";
import {EVENT_PAYMENT_CREDITS_NEEDED, EVENT_PAYMENT_UNLOCK_PRO, EVENT_MAX_CONCURRENT_CONVERSION} from "../events/payment.events";
import {APP_GENERIC_ERROR} from "../events/app.events";

class ApiResponseHandler {

    constructor() {
    }

    handle(response) {
        switch (response.status) {
            case 200:
                break;
            case 402:
                this._handlePremium(response);
                break;
            default:
                EventBus.$emit(APP_GENERIC_ERROR, {});
        }
    }

    _handlePremium(response) {
        switch (response.data[0].ident) {
            case 'rate_limit':
            case 'credits_consumed':
                EventBus.$emit(EVENT_PAYMENT_CREDITS_NEEDED, response.data);
                break;
            case 'concurrent_conversions':
                EventBus.$emit(EVENT_MAX_CONCURRENT_CONVERSION, {});
                break;
            default:
                EventBus.$emit(EVENT_PAYMENT_UNLOCK_PRO, {});
        }
    }
}

export default new ApiResponseHandler()